import React, { useEffect, useState, useCallback } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { Alert } from 'react-bootstrap'
import { getErrorMessageFromApiResponse } from '../../../utils/api/apiUtils'
import useStores from "../../../stores/useStore";
import instMgmtApi from '../../../utils/api/instanceMgmt/instMgmtApi'
import { ButtonWithLoadingState } from '../../Buttons'
import styled from 'styled-components'
import { t } from 'i18next'
import ScanCodeData from '../ScanCodeData'
import { Observer } from 'mobx-react'

const StyledButtonsWrapper = styled.div`
    .btn {
        margin: 4px;
    }
    display: flex;
    width: 100%;
    justify-content: space-between;
    
    @media screen and (max-width: 767px) {
        flex-direction: column;
        width: 100%;
    }
`
const JobModal = ({ handleClose, scanCode, isFirstScan = false }) => {
    const { washStore } = useStores()
    const [scanCodeObj, setScanCodeObj] = useState(null)
    const [currentJob, setCurrentJob] = useState(null)
    //const [jobChanged, setJobChanged] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const reloadScanCode = useCallback(async () => {
        try {
            setLoading(true)
            let result = await instMgmtApi.getScanCodeInfo(scanCode)
            if (isFirstScan) {
                result.wasAlreadyScaned = false
            }
            setScanCodeObj(result);
            let stationId = washStore.getSelectedWashStationId()
            let jobs = await instMgmtApi.getWashOpenJobsForScanCode(scanCode, stationId)
            let job = jobs.find(obj => (washStore.checkWashActionIsAllowed('closeRepairJob') && obj.type === "isRepairJob") || (washStore.checkWashActionIsAllowed('closeControlJob') && obj.type === "isControlJob"))
            if (!!job) {
                setCurrentJob(job)
            }
        }
        catch (e) {
            setError(getErrorMessageFromApiResponse(e))
        }
        finally {
            setLoading(false)
        }
    }, [scanCode, isFirstScan, washStore])

    const saveJob = async (action) => {
        try {
            setLoading(true)
            let stationId = washStore.getSelectedWashStationId()
            let params = {
                action: action,
                stationId: stationId,
                additionalWashCycles: scanCodeObj?.additionalWashCycles ?? 0,
                comment: scanCodeObj?.comment ?? '',
            }
            await instMgmtApi.postScanCodeAction(scanCodeObj.rfid, params)
            let result = await instMgmtApi.getScanCodeInfo(scanCodeObj.rfid)
            if (isFirstScan) {
                result.wasAlreadyScaned = false
            }
            setScanCodeObj(result);
            //setJobChanged(true);
            if ((washStore.checkWashActionIsAllowed('closeRepairJob') && !result?.hasRepairJob)
                || (washStore.checkWashActionIsAllowed('closeControlJob') && !result?.hasControlJob)) {
                handleClose(true)
            }
        }
        catch (e) {
            setError(getErrorMessageFromApiResponse(e))
        }
        finally {
            setLoading(false)
        }
    }
    /*const handleOnClose = () => {
        handleClose(jobChanged)
    }*/
    useEffect(() => {
        reloadScanCode()
    }, [reloadScanCode])
    const getTitle = () => {
        if (washStore.checkIsRepairStation() && scanCodeObj?.hasRepairJob) return t('washPage:repairJob')
        if (washStore.checkIsControlStation() && scanCodeObj?.hasControlJob) return t('washPage:controlJob')
        return washStore?.washStation?.displayName ?? ''
    }
    return <Observer>{() => (
        <Modal size='lg' centered show={true} onHide={handleClose} backdrop='static'>
            <Modal.Header closeButton={handleClose}>
                <Modal.Title >{getTitle()}</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <ScanCodeData
                    scanCodeObj={scanCodeObj}
                    setScanCodeObj={setScanCodeObj}
                    editable={washStore.checkWashActionIsAllowed('closeControlJob') && scanCodeObj?.hasControlJob}
                    disableComment={false}
                    disableCollapse={false}
                    currentJobObj={currentJob}
                />
                {error ? <Alert variant="danger">{error}</Alert> : null}
                {washStore.createErrorCode(scanCodeObj) ? <Alert variant="danger">{washStore.createErrorCode(scanCodeObj)}</Alert> : null}
                {washStore.createInfoCode(scanCodeObj) ? <Alert variant="info">{washStore.createInfoCode(scanCodeObj)}</Alert> : null}
            </Modal.Body >
            <Modal.Footer className="justify-content-start">
                <StyledButtonsWrapper>
                    {(washStore.checkWashActionIsAllowed('closeControlJob') && scanCodeObj?.hasControlJob) && <ButtonWithLoadingState
                        className='mb-2'
                        id='closeControlJob'
                        buttonText={t('washPage:closeJob')}
                        onClick={(e) => saveJob('closeControlJob')}
                        loading={loading}
                        disabled={loading || !scanCodeObj?.hasControlJob}
                    />}
                    {(washStore.checkWashActionIsAllowed('closeRepairJob') && scanCodeObj?.hasRepairJob) && <ButtonWithLoadingState
                        className='mb-2'
                        id='closeRepairJob'
                        buttonText={t('washPage:closeJob')}
                        onClick={(e) => saveJob('closeRepairJob')}
                        loading={loading}
                        disabled={loading || !scanCodeObj?.hasRepairJob}
                    />}
                    {washStore.checkWashActionIsAllowed('createControlJob') && <ButtonWithLoadingState
                        className='mb-2'
                        id='createControlJob'
                        buttonText={t('washPage:controlJob')}
                        onClick={(e) => saveJob('createControlJob')}
                        loading={loading}
                        disabled={loading || !!scanCodeObj?.hasControlJob}
                    />}
                    {washStore.checkWashActionIsAllowed('createRepairJob') && <ButtonWithLoadingState
                        className='mb-2'
                        id='createRepairJob'
                        buttonText={t('washPage:repairJob')}
                        onClick={(e) => saveJob('createRepairJob')}
                        loading={loading}
                        disabled={loading || !!scanCodeObj?.hasRepairJob}
                    />}
                    <Button variant="secondary" onClick={() => handleClose(false)}>{t('cancelButton')}</Button>
                </StyledButtonsWrapper>
            </Modal.Footer>
        </Modal>
    )}</Observer>
}

export default JobModal